module.exports = __webpack_public_path__ + "img/supporter.10d26df6.jpg";